/**
 * SiteGlue customer-facing terminology — Phase 1 dictionary.
 * Source: siteglue_brand_product_architecture_migration_plan_v2.md
 *
 * Use these strings on SiteGlue marketing and discovery surfaces.
 * Do not rename Stripe IDs, Prisma fields, MCP routes, hire plan ids,
 * event names, or URLs. EasyGPT / Inbound GPT copy stays unchanged.
 */

export const SITEGLUE_PRODUCT_NAME = "SiteGlue Agent";
export const SITEGLUE_PRODUCT_SHORT_NAME = "Agent";
export const SITEGLUE_COMPANY_NAME = "SiteGlue AI";
export const SITEGLUE_COMPANY_SHORT_NAME = "SiteGlue";

export const SITEGLUE_TAGLINE = "Agents Connecting People.";
export const SITEGLUE_HOMEPAGE_H1 = "Connect Every Conversation to the Right Person.";
export const SITEGLUE_BRAND_EXPRESSION = "Make Every Connection Stick.";

/** Agent-Ready is the acquisition campaign / scanner — not a product SKU. */
export const AGENT_READY_CAMPAIGN_NAME = "Agent-Ready";
export const AGENT_READY_SCAN_CTA = "Scan My Business";
export const AGENT_READY_CAMPAIGN_H1 = "Is Your Business Agent-Ready?";

export const SITEGLUE_DEPLOY_CTA = "Set Up Your Agent";
export const SITEGLUE_ACTIVATE_CTA = "Activate Your SiteGlue Agent";
export const SITEGLUE_OPEN_AGENT_CTA = "Open my Agent";

/** Current published plan display names. Do not invent replacement tier names. */
export const SITEGLUE_PLAN_DISPLAY_NAMES = [
  "Intern",
  "Associate",
  "Professional",
  "Enterprise",
] as const;

export const SITEGLUE_CUSTOMER_TERM_REPLACEMENTS = {
  "AI Employee": SITEGLUE_PRODUCT_NAME,
  "AI Employees": "SiteGlue Agents",
  "Hire an AI Employee": SITEGLUE_DEPLOY_CTA,
  "Hire Your First AI Employee": SITEGLUE_DEPLOY_CTA,
  "Onboard Your AI Employee": "Set Up Your Agent",
  "My AI Employee": "My Agent",
  "Open my AI Employee": SITEGLUE_OPEN_AGENT_CTA,
  "Employee training": "Agent Knowledge",
  "Employee tools": "Agent Capabilities",
  "AI Employee Blueprint": "Agent Blueprint",
  "AI Employee Platform": SITEGLUE_PRODUCT_NAME,
  "Browse AI Employees": "Browse Agents",
  "Explore Live AI Employees": "Explore Live Agents",
} as const;

export const SITEGLUE_ONE_PRODUCT_POSITIONING =
  "SiteGlue offers one product: SiteGlue Agent. Agent-Ready is the free website scanner and readiness report that helps businesses activate that Agent.";

export const SITEGLUE_BASE_INCLUDED_LABEL = "AI Agents + Live Chat + Connection Reporting";
